if (!customElements.get('browse-product-scene')) {
 customElements.define('browse-product-scene', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort=new AbortController();
   const options={signal:this.abort.signal};
   this.scrollOffset=0;
   const fit=()=>{
    const origin=this.getBoundingClientRect().top+window.scrollY-this.scrollOffset;
    this.style.setProperty('--browse-top',Math.max(0,origin)+'px');
    const buy=this.closest('.shopify-section')?.querySelector('[id^="BuyButtons-ProductSubmitButton-"]');
    const header=document.querySelector('header-component');
    const top=Math.max(0,header?.getBoundingClientRect().bottom||0);
    const stop=buy?buy.getBoundingClientRect().top+window.scrollY-origin-this.offsetHeight-16:0;
    this.scrollOffset=matchMedia('(max-width:749px)').matches?Math.max(0,Math.min(window.scrollY+top-origin,stop)):0;
    this.style.setProperty('--browse-scroll-offset',this.scrollOffset+'px');
   };
   let queued=false;
   window.addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;fit();});}},{...options,passive:true});
   window.addEventListener('resize',fit,options);
   this.resizeObserver?.disconnect();this.resizeObserver=new ResizeObserver(fit);
   const header=document.querySelector('header-component');if(header)this.resizeObserver.observe(header);
   requestAnimationFrame(fit);
   this.frame=this.querySelector('iframe'); this.light=this.querySelector('.browse-light');
   this.type=this.dataset.variantId==='53464919933217'?'wall':'table';
   this.lightOn=false;
   this.send=()=>this.frame.contentWindow?.postMessage({channel:'browse-scene',type:'set-state',state:{lampType:this.type,lightOn:this.lightOn}},location.origin);
   this.sync=()=>{
    const picker=document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"][data-template-product-match="true"]`);
    const input=picker?.querySelector('input[data-option-name="Type"]:checked,select[name="options[Type]"]');
    const selected={'Table lamp':'table','Wall lamp':'wall'}[input?.value];
    if(selected)this.type=selected;
    this.send();
   };
   this.light.addEventListener('click',()=>{this.lightOn=!this.lightOn;this.light.setAttribute('aria-checked',String(this.lightOn));this.send();},options);
   document.addEventListener('change',event=>{
    const picker=event.target.closest?.('variant-picker');
    if(picker?.dataset.productId===this.dataset.productId && picker.dataset.templateProductMatch==='true')this.sync();
   },options);
   window.addEventListener('message',event=>{
    if(event.source!==this.frame.contentWindow||event.origin!==location.origin||event.data?.channel!=='browse-scene')return;
    if(event.data.type==='ready'){this.dataset.ready='true';this.sync();}
   },options);
   window.addEventListener('popstate',()=>{this.type=new URL(location.href).searchParams.get('variant')==='53464919933217'?'wall':'table';this.send();},options);
   this.frame.addEventListener('load',()=>this.frame.contentWindow?.postMessage({channel:'browse-scene',type:'get-state'},location.origin),options);
  }
  disconnectedCallback(){this.abort?.abort();this.resizeObserver?.disconnect();}
 });
}
